module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nlet icon                    = formMapping.icon;\nconst iconColor             = formMapping.iconColor;\nconst buttonType            = formMapping.buttonType;\nconst context               = formMapping.context;\nconst buttonContext         = formMapping.buttonContext;\nconst mode                  = formMapping.mode;\nconst symbolOnly            = !!formMapping.symbolOnly;\nconst additionalSymbol      = formMapping.additionalSymbol;\nconst inline                = !!formMapping.inline;\nconst additionalClass       = formMapping.additionalClass;\nconst buttonTextKey         = formMapping.buttonTextKey || formMapping.buttonText || 'button:' + (buttonType || 'all') + '.' + (buttonContext || context || 'all') + '.' + (mode || 'all');\nconst buttonText            = storage.__(buttonTextKey);\nconst title                 = formMapping.title || buttonText || '';\nlet neutral                 = !!formMapping.neutral;\nlet negative                = !!formMapping.negative;\nlet positive                = !!formMapping.positive;\nlet usage                   = !!formMapping.usage;\nconst forceTag              = formMapping.forceTag || 'button';\nconst tabIndex              = formMapping.preventTabIndex ? -1 : undefined\nconst defaultIconClass      = 'fi fi-' + (buttonType ? buttonType + '-' : '') + ((buttonContext || context) ? (buttonContext || context) : 'default');\nif(!icon && buttonType){\nswitch(buttonType){\n// case 'pay':\n// \ticon = 'fi fi-pay';\n// \tbreak;\ncase 'import':\ncase 'showImport':\nicon = 'fi fi-upload';\nbreak;\ncase 'view':\nicon = 'fi fi-eye';\nbreak;\ncase 'download':\ncase 'export':\ncase 'showExport':\ncase 'showExportOptions':\nicon = 'fi fi-download';\nswitch(mode) {\ncase 'copy':    icon = 'fi fi-download'; break;\ncase 'csv':     icon = 'fi fi-download'; break;\ncase 'excel':   icon = 'fi fi-download'; break;\ncase 'pdf':     icon = 'fi fi-download'; break;\ncase 'print':   icon = 'fi fi-download'; break;\n}\nbreak;\ncase 'cancel':\ncase 'no':\ncase 'close':                   icon = 'fi fi-times'; negative = true; break;\ncase 'done':                    icon = 'fi fi-check'; positive = true; break;\n// case 'connectLanguage':         icon = 'fi fi-connect-language'; break;\n// case 'connectLayout':           icon = 'fi fi-connect-layout'; break;\ncase 'delete':\nicon = 'fi fi-trash';\nnegative = true;\nswitch(context) {\ncase 'segmentData':     icon = 'fi fi-times'; break;\ncase 'flatScaleEntry':  negative = false; break;\n// case 'flatScaleEntry':  icon = 'fi fi-minus-circle'; negative = false; break;\n}\nbreak;\ncase 'setEmployeeJobPrice':\nicon = 'fi fi-euro'\nbreak;\n// case 'showDuplicateOptions':\n// case 'showDuplicate':\n// case 'duplicate':               icon = 'fi fi-copy'; break;\n// case 'assign':\n// case 'showAssign':\n//     icon = 'fi fi-assign';\n//     switch(context) {\n//         case 'tags':\n//         \ticon = 'fi fi-assign-tags'\n//             switch(mode) {\n//                 case 'empty':\n//                     icon = 'fi fi-trash'\n//                     break;\n//                 case 'selected':\n//                     icon = 'fi fi-filter'\n//                     break;\n//             }\n//             break;\n//         case 'routes':\n//         \ticon = 'fi fi-assign-tags'\n//             switch(mode) {\n//                 case 'empty':\n//                     icon = 'fi fi-trash'\n//                     break;\n//                 case 'reset':\n//                     icon = 'fi fi-times'\n//                     break;\n//                 case 'selected':\n//                     icon = 'fi fi-filter'\n//                     break;\n//             }\n//             break;\n//     }\n//     break;\n// case 'showFilter':\n//     icon = 'fi fi-filter';\n//     switch(context) {\n//         case 'tags':\n//             switch(mode) {\n//                 case 'empty':\n//                     icon = 'fi fi-trash'\n//                     break;\n//             }\n//             break;\n//     }\n// \tbreak;\n// case 'filter':                  icon = 'fi fi-filter'; break;\n// case 'fullScreen':              icon = 'fi fi-full-screen'; break;\n// case 'closeFullScreen':         icon = 'fi fi-close-full-screen'; break;\ncase 'showEdit':\ncase 'edit':\nicon = 'fi fi-edit';\nswitch(context) {\ncase 'timeRecordings':\ncase 'timeRecordings_projectTerm':\nicon = 'fi fi-time-recording';\nswitch(mode) {\ncase 'timeRegistration':                icon = 'fi fi-time-registration';   break;\ncase 'shippingOrder':                   icon = 'fi fi-shipping-order';      break;\n}\nbreak;\ncase 'shippingOrders':\nicon = 'fi fi-shipping-order';\nbreak;\n//         case 'serviceUsers':\n//             icon = 'fi fi-users';\n//             break;\n//\n//         case 'categoryData':\n//             switch(mode) {\n//                 case 'asDefault':   icon = 'fi fi-setDefault-categoryData'; break;\n//             }\n//         \tbreak;\n//\n//         case 'route':\n//             switch(mode) {\n//                 case 'asHome':      icon = 'fi fi-home'; break;\n//             }\n//             break;\n//\n//         case 'media-image':\n//             switch(mode) {\n//                 case 'assign':      icon = 'fi fi-mediaImage'; break;\n//             }\n//             break;\n//\n//         case 'media-file':\n//             switch(mode) {\n//                 case 'assign':      icon = 'fi fi-mediaFile'; break;\n//             }\n//             break;\n//\n//         case 'address':\n//             switch(mode) {\n//                 case 'details':      icon = 'fi fi-mailing-address'; break;\n//             }\n//             break;\n//\n//         case 'mailingUrl':\n//             icon = 'fi fi-mailingUrl-viewSubscribers'\n//             break;\n//\n//         case 'subProducts':\n//             icon = 'fi fi-shop-product'\n//             break;\n}\nbreak;\n//\n// case 'showPreview':\n//     icon = 'fi fi-search'\n// \tbreak;\n// case 'showMove':\n// \ticon = 'fi fi-move';\n// \tbreak;\n//\n// case 'move':\n// \ticon = 'fi fi-move-all';\n//     switch(mode) {\n//         case 'up':          icon = 'fi fi-move-up'; break;\n//         case 'down':        icon = 'fi fi-move-down'; break;\n//         case 'left':        icon = 'fi fi-move-left'; break;\n//         case 'right':       icon = 'fi fi-move-right'; break;\n//     }\n// \tbreak;\n//\n// case 'moveToStart':\n// \ticon = 'fi fi-arrow-up-stop';\n//     break;\n// case 'moveToBefore':\n// \ticon = 'fi fi-arrow-up';\n//     break;\n// case 'moveToAfter':\n// \ticon = 'fi fi-arrow-down';\n//     break;\n// case 'moveToEnd':\n// \ticon = 'fi fi-arrow-down-stop';\n//     break;\n//\n//\n// case 'showSelect':\n// case 'select':\n// \ticon = 'fi fi-select';\n//     switch(context) {\n//         case 'products':\n//             switch(mode) {\n//                 case 'empty':\n//                     icon = 'fi fi-trash';\n//                     break;\n//             }\n//             break;\n//     }\n//     break;\n//\n// case 'showSelectColumns':\n//     icon = 'fi fi-show-select-columns'\n//     break;\n//\n// case 'selectAll':\n//     icon = 'fi fi-select';\n//     if(context){\n//         icon = `fi fi-selectAll-${context}`\n//     }\n//     break;\n// case 'deselectAll':\n//     icon = 'fi fi-select';\n//     if(context){\n//         icon = `fi fi-deselectAll-${context}`\n//     }\n//     break;\n//\ncase 'open':\nicon = 'fi fi-open';\nbreak\ncase 'showInsert':\ncase 'insert':\nicon = 'fi fi-plus';\nswitch(context) {\ncase 'flatScaleEntry':         icon = 'fi fi-plus-circle'; break;\n// case 'category':        icon = 'fi fi-category'; break;\n// case 'categoryData':    icon = 'fi fi-categoryData'; break;\n// case 'database':        icon = 'fi fi-database'; break;\n// case 'atom':            icon = 'fi fi-atom'; break;\n// case 'component':       icon = 'fi fi-component'; break;\n// case 'layout':          icon = 'fi fi-layout'; break;\n// case 'service':         icon = 'fi fi-service'; break;\n// case 'assignedService': icon = 'fi fi-assignedService'; break;\n// case 'scope':           icon = 'fi fi-scope'; break;\n// case 'scopeRole':       icon = 'fi fi-scopeRole'; break;\n// case 'privilege':       icon = 'fi fi-privilege'; break;\n// case 'user':            icon = 'fi fi-user'; break;\n// case 'serviceUser':     icon = 'fi fi-serviceUser'; break;\n// case 'validator':       icon = 'fi fi-validator'; break;\n// case 'banner':          icon = 'fi fi-banner'; break;\n// case 'client':          icon = 'fi fi-client'; break;\n// case 'newsletter':      icon = 'fi fi-newsletter'; break;\n// case 'address':         icon = 'fi fi-plus-circle'; break;\n// case 'activity':        icon = 'fi fi-plus-circle'; break;\n// case 'trip':            icon = 'fi fi-plus-circle'; break;\n// case 'product':         icon = 'fi fi-shop-product'; break;\n// case 'productState':\n// case 'productPrice':    icon = 'fi fi-plus-circle'; break;\n}\nbreak;\ncase 'signIn':                  icon = 'fi fi-sign-in'; positive = true; break;\ncase 'submit':\ncase 'submitRefresh':\ncase 'save':\nicon = 'fi fi-check';\npositive = true;\nswitch(context) {\ncase 'signIn':          icon = 'fi fi-sign-in'; break;\n}\nbreak;\ncase 'yes':                     icon = 'fi fi-check'; positive = true; break;\n// case 'users':                   icon = 'fi fi-users'; break;\ncase 'renew':\ncase 'refresh':\ncase 'refreshData':\nicon = 'fi fi-refresh';\nbreak;\ncase 'lazyload':{\nicon = 'fi fi-lazyload';\nbreak;\n}\n// case 'send':\n// case 'schedule':\n// \ticon = 'fi fi-check';\n// \tbreak;\n// case 'abort':\n// case 'unschedule':\n// \ticon = 'fi fi-times';\n// \tnegative = true;\n// \tbreak;\ncase 'reset':\nicon = 'fi fi-reset';\nnegative = true;\nbreak;\n// case 'resend':\n// \ticon = 'fi fi-resend';\n// \tnegative = true;\n// \tbreak;\n// case 'showProtocol':\n// \ticon = 'fi fi-protocol';\n// \tbreak;\n// case 'addNinjaComponentInstance':\n//     icon = 'fi fi-plus-circle';\n//     break;\ncase 'navToList':\nicon = 'fi fi-list';\nbreak;\ncase 'selectAlternativeTab':\nicon = 'fi fi-select-alternative-tab';\nbreak;\ncase 'decisionComponent':\ncase 'default':\ndefault:                        icon = defaultIconClass; break;\n}\n}\nconst additionalClasses = []\nif(!neutral){\nif(negative)        additionalClasses.push('negative');\nelse if(positive)   additionalClasses.push('positive');\nelse if(usage)      additionalClasses.push('usage');\n}\nif(symbolOnly){\nadditionalClasses.push('symbolOnly');\n}\nif(inline){\nadditionalClasses.push('inline');\n}\nif(additionalClass){\nadditionalClasses.push(additionalClass)\n}\nconst additionalAttributes = formMapping.additionalAttributes || []\nconst preparedAdditionalAttributes = ['']\nlet a\nfor(a in additionalAttributes){\npreparedAdditionalAttributes.push(`${a}=\"${additionalAttributes[a]}\"`)\n}\nconst additionalStyles = []\nif(iconColor){\nadditionalStyles.push(`--fec-button-icon-color: ${iconColor};`)\n}\nif(additionalStyles.length > 0){\npreparedAdditionalAttributes.push(`style=\"${additionalStyles.join(' ')}\"`)\n}\nif(tabIndex !== undefined){\npreparedAdditionalAttributes.push(`tabIndex=\"${tabIndex}\"`)\n}\n%>\n<<%- forceTag %> class=\"<%- additionalClasses.join(' '); %>\" data-field-type=\"<%- buttonType %>\" data-button-context=\"<%- context %>\" data-button-mode=\"<%- mode %>\" title=\"<%= title %>\"<%- preparedAdditionalAttributes.join(' ') %>><%\nif(additionalSymbol){\n%><i class=\"additionalSymbol <%= additionalSymbol %>\"></i><%\n}\n%><i class=\"<%- icon %>\"></i><%\n%><%= (!symbolOnly ? title : '') %><%\n%></<%- forceTag %>>"
  , __filename = "components/templates/core/form/elements/buttons/default.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
let icon                    = formMapping.icon;
const iconColor             = formMapping.iconColor;
const buttonType            = formMapping.buttonType;
const context               = formMapping.context;
const buttonContext         = formMapping.buttonContext;
const mode                  = formMapping.mode;
const symbolOnly            = !!formMapping.symbolOnly;
const additionalSymbol      = formMapping.additionalSymbol;
const inline                = !!formMapping.inline;
const additionalClass       = formMapping.additionalClass;
const buttonTextKey         = formMapping.buttonTextKey || formMapping.buttonText || 'button:' + (buttonType || 'all') + '.' + (buttonContext || context || 'all') + '.' + (mode || 'all');
const buttonText            = storage.__(buttonTextKey);
const title                 = formMapping.title || buttonText || '';
let neutral                 = !!formMapping.neutral;
let negative                = !!formMapping.negative;
let positive                = !!formMapping.positive;
let usage                   = !!formMapping.usage;
const forceTag              = formMapping.forceTag || 'button';
const tabIndex              = formMapping.preventTabIndex ? -1 : undefined
const defaultIconClass      = 'fi fi-' + (buttonType ? buttonType + '-' : '') + ((buttonContext || context) ? (buttonContext || context) : 'default');
if(!icon && buttonType){
switch(buttonType){
// case 'pay':
// 	icon = 'fi fi-pay';
// 	break;
case 'import':
case 'showImport':
icon = 'fi fi-upload';
break;
case 'view':
icon = 'fi fi-eye';
break;
case 'download':
case 'export':
case 'showExport':
case 'showExportOptions':
icon = 'fi fi-download';
switch(mode) {
case 'copy':    icon = 'fi fi-download'; break;
case 'csv':     icon = 'fi fi-download'; break;
case 'excel':   icon = 'fi fi-download'; break;
case 'pdf':     icon = 'fi fi-download'; break;
case 'print':   icon = 'fi fi-download'; break;
}
break;
case 'cancel':
case 'no':
case 'close':                   icon = 'fi fi-times'; negative = true; break;
case 'done':                    icon = 'fi fi-check'; positive = true; break;
// case 'connectLanguage':         icon = 'fi fi-connect-language'; break;
// case 'connectLayout':           icon = 'fi fi-connect-layout'; break;
case 'delete':
icon = 'fi fi-trash';
negative = true;
switch(context) {
case 'segmentData':     icon = 'fi fi-times'; break;
case 'flatScaleEntry':  negative = false; break;
// case 'flatScaleEntry':  icon = 'fi fi-minus-circle'; negative = false; break;
}
break;
case 'setEmployeeJobPrice':
icon = 'fi fi-euro'
break;
// case 'showDuplicateOptions':
// case 'showDuplicate':
// case 'duplicate':               icon = 'fi fi-copy'; break;
// case 'assign':
// case 'showAssign':
//     icon = 'fi fi-assign';
//     switch(context) {
//         case 'tags':
//         	icon = 'fi fi-assign-tags'
//             switch(mode) {
//                 case 'empty':
//                     icon = 'fi fi-trash'
//                     break;
//                 case 'selected':
//                     icon = 'fi fi-filter'
//                     break;
//             }
//             break;
//         case 'routes':
//         	icon = 'fi fi-assign-tags'
//             switch(mode) {
//                 case 'empty':
//                     icon = 'fi fi-trash'
//                     break;
//                 case 'reset':
//                     icon = 'fi fi-times'
//                     break;
//                 case 'selected':
//                     icon = 'fi fi-filter'
//                     break;
//             }
//             break;
//     }
//     break;
// case 'showFilter':
//     icon = 'fi fi-filter';
//     switch(context) {
//         case 'tags':
//             switch(mode) {
//                 case 'empty':
//                     icon = 'fi fi-trash'
//                     break;
//             }
//             break;
//     }
// 	break;
// case 'filter':                  icon = 'fi fi-filter'; break;
// case 'fullScreen':              icon = 'fi fi-full-screen'; break;
// case 'closeFullScreen':         icon = 'fi fi-close-full-screen'; break;
case 'showEdit':
case 'edit':
icon = 'fi fi-edit';
switch(context) {
case 'timeRecordings':
case 'timeRecordings_projectTerm':
icon = 'fi fi-time-recording';
switch(mode) {
case 'timeRegistration':                icon = 'fi fi-time-registration';   break;
case 'shippingOrder':                   icon = 'fi fi-shipping-order';      break;
}
break;
case 'shippingOrders':
icon = 'fi fi-shipping-order';
break;
//         case 'serviceUsers':
//             icon = 'fi fi-users';
//             break;
//
//         case 'categoryData':
//             switch(mode) {
//                 case 'asDefault':   icon = 'fi fi-setDefault-categoryData'; break;
//             }
//         	break;
//
//         case 'route':
//             switch(mode) {
//                 case 'asHome':      icon = 'fi fi-home'; break;
//             }
//             break;
//
//         case 'media-image':
//             switch(mode) {
//                 case 'assign':      icon = 'fi fi-mediaImage'; break;
//             }
//             break;
//
//         case 'media-file':
//             switch(mode) {
//                 case 'assign':      icon = 'fi fi-mediaFile'; break;
//             }
//             break;
//
//         case 'address':
//             switch(mode) {
//                 case 'details':      icon = 'fi fi-mailing-address'; break;
//             }
//             break;
//
//         case 'mailingUrl':
//             icon = 'fi fi-mailingUrl-viewSubscribers'
//             break;
//
//         case 'subProducts':
//             icon = 'fi fi-shop-product'
//             break;
}
break;
//
// case 'showPreview':
//     icon = 'fi fi-search'
// 	break;
// case 'showMove':
// 	icon = 'fi fi-move';
// 	break;
//
// case 'move':
// 	icon = 'fi fi-move-all';
//     switch(mode) {
//         case 'up':          icon = 'fi fi-move-up'; break;
//         case 'down':        icon = 'fi fi-move-down'; break;
//         case 'left':        icon = 'fi fi-move-left'; break;
//         case 'right':       icon = 'fi fi-move-right'; break;
//     }
// 	break;
//
// case 'moveToStart':
// 	icon = 'fi fi-arrow-up-stop';
//     break;
// case 'moveToBefore':
// 	icon = 'fi fi-arrow-up';
//     break;
// case 'moveToAfter':
// 	icon = 'fi fi-arrow-down';
//     break;
// case 'moveToEnd':
// 	icon = 'fi fi-arrow-down-stop';
//     break;
//
//
// case 'showSelect':
// case 'select':
// 	icon = 'fi fi-select';
//     switch(context) {
//         case 'products':
//             switch(mode) {
//                 case 'empty':
//                     icon = 'fi fi-trash';
//                     break;
//             }
//             break;
//     }
//     break;
//
// case 'showSelectColumns':
//     icon = 'fi fi-show-select-columns'
//     break;
//
// case 'selectAll':
//     icon = 'fi fi-select';
//     if(context){
//         icon = `fi fi-selectAll-${context}`
//     }
//     break;
// case 'deselectAll':
//     icon = 'fi fi-select';
//     if(context){
//         icon = `fi fi-deselectAll-${context}`
//     }
//     break;
//
case 'open':
icon = 'fi fi-open';
break
case 'showInsert':
case 'insert':
icon = 'fi fi-plus';
switch(context) {
case 'flatScaleEntry':         icon = 'fi fi-plus-circle'; break;
// case 'category':        icon = 'fi fi-category'; break;
// case 'categoryData':    icon = 'fi fi-categoryData'; break;
// case 'database':        icon = 'fi fi-database'; break;
// case 'atom':            icon = 'fi fi-atom'; break;
// case 'component':       icon = 'fi fi-component'; break;
// case 'layout':          icon = 'fi fi-layout'; break;
// case 'service':         icon = 'fi fi-service'; break;
// case 'assignedService': icon = 'fi fi-assignedService'; break;
// case 'scope':           icon = 'fi fi-scope'; break;
// case 'scopeRole':       icon = 'fi fi-scopeRole'; break;
// case 'privilege':       icon = 'fi fi-privilege'; break;
// case 'user':            icon = 'fi fi-user'; break;
// case 'serviceUser':     icon = 'fi fi-serviceUser'; break;
// case 'validator':       icon = 'fi fi-validator'; break;
// case 'banner':          icon = 'fi fi-banner'; break;
// case 'client':          icon = 'fi fi-client'; break;
// case 'newsletter':      icon = 'fi fi-newsletter'; break;
// case 'address':         icon = 'fi fi-plus-circle'; break;
// case 'activity':        icon = 'fi fi-plus-circle'; break;
// case 'trip':            icon = 'fi fi-plus-circle'; break;
// case 'product':         icon = 'fi fi-shop-product'; break;
// case 'productState':
// case 'productPrice':    icon = 'fi fi-plus-circle'; break;
}
break;
case 'signIn':                  icon = 'fi fi-sign-in'; positive = true; break;
case 'submit':
case 'submitRefresh':
case 'save':
icon = 'fi fi-check';
positive = true;
switch(context) {
case 'signIn':          icon = 'fi fi-sign-in'; break;
}
break;
case 'yes':                     icon = 'fi fi-check'; positive = true; break;
// case 'users':                   icon = 'fi fi-users'; break;
case 'renew':
case 'refresh':
case 'refreshData':
icon = 'fi fi-refresh';
break;
case 'lazyload':{
icon = 'fi fi-lazyload';
break;
}
// case 'send':
// case 'schedule':
// 	icon = 'fi fi-check';
// 	break;
// case 'abort':
// case 'unschedule':
// 	icon = 'fi fi-times';
// 	negative = true;
// 	break;
case 'reset':
icon = 'fi fi-reset';
negative = true;
break;
// case 'resend':
// 	icon = 'fi fi-resend';
// 	negative = true;
// 	break;
// case 'showProtocol':
// 	icon = 'fi fi-protocol';
// 	break;
// case 'addNinjaComponentInstance':
//     icon = 'fi fi-plus-circle';
//     break;
case 'navToList':
icon = 'fi fi-list';
break;
case 'selectAlternativeTab':
icon = 'fi fi-select-alternative-tab';
break;
case 'decisionComponent':
case 'default':
default:                        icon = defaultIconClass; break;
}
}
const additionalClasses = []
if(!neutral){
if(negative)        additionalClasses.push('negative');
else if(positive)   additionalClasses.push('positive');
else if(usage)      additionalClasses.push('usage');
}
if(symbolOnly){
additionalClasses.push('symbolOnly');
}
if(inline){
additionalClasses.push('inline');
}
if(additionalClass){
additionalClasses.push(additionalClass)
}
const additionalAttributes = formMapping.additionalAttributes || []
const preparedAdditionalAttributes = ['']
let a
for(a in additionalAttributes){
preparedAdditionalAttributes.push(`${a}="${additionalAttributes[a]}"`)
}
const additionalStyles = []
if(iconColor){
additionalStyles.push(`--fec-button-icon-color: ${iconColor};`)
}
if(additionalStyles.length > 0){
preparedAdditionalAttributes.push(`style="${additionalStyles.join(' ')}"`)
}
if(tabIndex !== undefined){
preparedAdditionalAttributes.push(`tabIndex="${tabIndex}"`)
}

    ; __line = 354
    ; __append("\n<")
    ; __line = 355
    ; __append( forceTag )
    ; __append(" class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-field-type=\"")
    ; __append( buttonType )
    ; __append("\" data-button-context=\"")
    ; __append( context )
    ; __append("\" data-button-mode=\"")
    ; __append( mode )
    ; __append("\" title=\"")
    ; __append(escapeFn( title ))
    ; __append("\"")
    ; __append( preparedAdditionalAttributes.join(' ') )
    ; __append(">")
    ; 
if(additionalSymbol){

    ; __line = 357
    ; __append("<i class=\"additionalSymbol ")
    ; __append(escapeFn( additionalSymbol ))
    ; __append("\"></i>")
    ; 
}

    ; __line = 359
    ; __append("<i class=\"")
    ; __append( icon )
    ; __append("\"></i>")
    ; 

    ; __line = 360
    ; __append(escapeFn( (!symbolOnly ? title : '') ))
    ; 

    ; __line = 361
    ; __append("</")
    ; __append( forceTag )
    ; __append(">")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/form/elements/buttons/default.ejs

}